import controllerLoadedObservableFactory from '@newswebsiteapp/shared/observables/controllerLoadedObservableFactory'

controllerLoadedObservableFactory('publication_list_page').subscribe(() => {
  $('[data-publication-readmore]').click(function (e) {
    e.preventDefault()

    const this$ = $(this)
    const baseLink = this$.attr('href')

    const publicationContentSelector = this$.data('publication-readmore')
    const publicationContent$ = $(publicationContentSelector)

    const paragraphsNumber = publicationContent$.find('p').length || 1

    const query = $.param({
      scroll_to_paragraph: paragraphsNumber,
    })

    const link = `${baseLink}?${query}`

    Turbolinks.visit(link)
  })
})
